import { createSlice } from '@reduxjs/toolkit'

export const statementOptionsSlice = createSlice({
    name: 'statementOptions',
    initialState: {
        result: [],
    },
    reducers: {
        setStatementOptions: (state, action) => {
            state.result = action.payload;
        }
    },
})

export const { setStatementOptions } = statementOptionsSlice.actions;

export const getStatementOptions = (state) => state.statementOptions.result;

export default statementOptionsSlice.reducer